import { cn } from "@/modules/lib/utils"
import { TrainingProgramsFiltersView } from "@modules/training/components/trainingProgramsFilterView"

type TrainingProgramsTabProps = {
  allowProgramSelection?: boolean
  className?: string
} & React.ComponentProps<"div">

export function TrainingProgramsTab({ allowProgramSelection, className, ...props }: TrainingProgramsTabProps) {
  return (
    <div className={cn("flex h-full w-full flex-col pt-16", className)} {...props}>
      <TrainingProgramsFiltersView allowProgramSelection={allowProgramSelection ?? false} />
    </div>
  )
}
